import { useEffect, useState } from "react";
import pdfIcon from "../image/pdf.png";
import wordIcon from "../image/word_icon.png";
import excelIcon from "../image/xls_icon.png";
import pptIcon from "../image/ppt_icon.png"; // ✅ Add your PPT icon
import { mainTable } from "../css/Common";

const DocumentRepositoryPopup = ({ data, submitData }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showFileModal, setShowFileModal] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);

  const fileUrl = data?.Attachment;
  const fileExtension = fileUrl?.split(".").pop()?.toLowerCase();

  const isImage = ["png", "jpg", "jpeg", "gif", "webp"].includes(fileExtension);
  const isPdf = fileExtension === "pdf";
  const isWord = ["doc", "docx"].includes(fileExtension);
  const isExcel = ["xls", "xlsx"].includes(fileExtension);
  const isPPT = ["ppt", "pptx"].includes(fileExtension); // ✅ PPT check

  const handleSubmit = (value) => {
    submitData(value === 1 ? 1 : 2);
  };

  const handlePreview = () => {
    setPreviewUrl(fileUrl);
    setShowFileModal(true);
  };

  const getViewerUrl = (url) => {
    if (!url) return "";
    const ext = url.split(".").pop().toLowerCase();
    const officeExt = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
    if (ext === "pdf") return url;
    if (officeExt.includes(ext)) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
    }
    return "";
  };

  useEffect(() => {
    setPreviewUrl(null);
    setShowFileModal(false);
  }, [data]);

  const renderFilePreview = () => {
    if (isImage) {
      return <img src={fileUrl} alt="Attachment" className="w-16 h-16 border rounded" />;
    } else if (isPdf) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={pdfIcon} alt="PDF" />
        </div>
      );
    } else if (isWord) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={wordIcon} alt="Word Document" />
        </div>
      );
    } else if (isExcel) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={excelIcon} alt="Excel Document" />
        </div>
      );
    } else if (isPPT) {
      return (
        <div className="cursor-pointer w-16" onClick={handlePreview}>
          <img src={pptIcon} alt="PowerPoint Document" />
        </div>
      );
    } else {
      return <span className="text-gray-500">Unsupported file format</span>;
    }
  };

  return (
    <div className="w-full">
      <div className={mainTable.mainContentScreen}>
        <div className="flex justify-center">
          <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
            <div className="w-full space-y-4">
              <div className="flex">
                <label className="w-40 font-semibold">Document Name</label>
                <label>: {data?.DocumentName}</label>
              </div>
              <div className="flex">
                <label className="w-40 font-semibold">File Name</label>
                <label>: {data?.FileName}</label>
              </div>
              <div className="flex">
                <label className="w-40 font-semibold">Uploaded Date & Time</label>
                <label>: {data?.FormattedDate}</label>
              </div>
              <div className="flex">
                <label className="w-40 font-semibold">No Of References</label>
                <label>: {data?.NoOfReferences}</label>
              </div>
              <div className="flex items-center">
                <label className="w-40 font-semibold">File Type</label>
                <span className="mr-2">:</span>
                {renderFilePreview()}
              </div>
            </div>
          </form>
        </div>

        <div className={mainTable.submitCancelMainDiv}>
          <button
            data-modal-hide="bottom-right-modal"
            type="button"
            className={disabledBtn ? mainTable.disabledSubmitButton : mainTable.submitButton}
            onClick={() => handleSubmit(1)}
            disabled={disabledBtn}
          >
            Delete
          </button>
          <button
            data-modal-hide="bottom-right-modal"
            type="button"
            className={mainTable.cancelButton}
            onClick={() => handleSubmit(2)}
          >
            CANCEL
          </button>
        </div>
      </div>

      {/* Preview Modal */}
      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)}
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            {previewUrl ? (
              isPdf || isWord || isExcel || isPPT ? (
                <iframe
                  src={getViewerUrl(previewUrl)}
                  title="File Viewer"
                  className="w-full h-[80vh] rounded"
                />
              ) : isImage ? (
                <img
                  src={previewUrl}
                  alt="Preview"
                  className="w-full h-auto max-h-[80vh] object-contain rounded"
                />
              ) : (
                <p className="text-center text-gray-600">
                  Preview not available for this file type.
                </p>
              )
            ) : (
              <p className="text-center text-gray-600">
                No file selected or file not available.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentRepositoryPopup;
